import { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { Sidebar } from "@/components/Sidebar";
import { UptimeMonitor } from "@/components/UptimeMonitor";
import { ImageMonitor } from "@/components/ImageMonitor";
import { SEOMonitor } from "@/components/SEOMonitor";
import { OnPageMonitor } from "@/components/OnPageMonitor";
import { SectionMonitor } from "@/components/SectionMonitor";
import { PageSpeedMonitor } from "@/components/PageSpeedMonitor";
import { TechSEOMonitor } from "@/components/TechSEOMonitor";
import { AlertRules } from "@/components/AlertRules";
import { Settings } from "@/components/Settings";
import { Analytics } from "@/components/Analytics";
import { MetaAltQuality } from "@/components/MetaAltQuality";
import { PasscodeScreen, useAuth } from "@/components/PasscodeScreen";
import { cn } from "@/lib/utils";

function App() {
  const { isAuthenticated, isLoading, authenticate } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState("uptime");

  // Show loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Show passcode screen if not authenticated
  if (!isAuthenticated) {
    return <PasscodeScreen onAuthenticated={authenticate} />;
  }

  const renderContent = () => {
    switch (activeTab) {
      case "uptime":
        return <UptimeMonitor />;
      case "images":
        return <ImageMonitor />;
      case "seo":
        return <SEOMonitor />;
      case "metaalt-quality":
        return <MetaAltQuality />;
      case "onpage":
        return <OnPageMonitor />;
      case "sections":
        return <SectionMonitor />;
      case "pagespeed":
        return <PageSpeedMonitor />;
      case "techseo":
        return <TechSEOMonitor />;
      case "analytics":
        return <Analytics />;
      case "alerts":
        return <AlertRules />;
      case "settings":
        return <Settings />;
      default:
        return <UptimeMonitor />;
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b]">
      <Toaster 
        theme="dark" 
        position="top-right"
        toastOptions={{
          style: {
            background: '#18181b',
            border: '1px solid #27272a',
            color: '#fafafa',
            fontFamily: 'JetBrains Mono, monospace'
          }
        }}
      />
      
      {/* Sidebar */}
      <Sidebar 
        isCollapsed={sidebarCollapsed}
        setIsCollapsed={setSidebarCollapsed}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      {/* Main Content */}
      <main 
        className={cn(
          "min-h-screen transition-all duration-300",
          sidebarCollapsed ? "ml-16" : "ml-56"
        )}
      >
        {renderContent()}
      </main>
    </div>
  );
}

export default App;
